import React from "react";
import styled from "@emotion/styled";

const Container = styled.img`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: 50px;
  object-fit: cover;
`;

interface Props {
  image: string;

  width?: number;
  height?: number;
}

export const GameCircle: React.FC<Props> = (props) => {
  const width = props.width || 200;
  const height = props.height || 200;
  return (
    <Container src={props.image} width={width} height={height}></Container>
  );
};
